import { noop } from "lodash";
import { action, makeObservable, observable } from "mobx";
import { CachedItem } from "@lib-shared/lib";
import { Installation } from "./models/installation-response";
import SearchDetails from "./models/search-details";
import OtpDetails from "./models/validate-details";

const cache = new CachedItem("track-my-installations");

class TrackingStore {
    installation: Installation | undefined;
    installations: Array<Installation> = [];
    installationReference = "";
    isLoading = false;
    otpError: string | undefined;
    otpLastSent: Date | undefined;
    searchDetails = new SearchDetails();
    searchError: string | undefined;
    page = "";
    otpDetails = new OtpDetails();

    onPageChange: any;

    constructor(onPageChange: any | undefined = undefined) {
        if (cache.isCached) {
            this.installations = cache.value;
        }

        this.onPageChange = onPageChange ?? noop;

        makeObservable(this, {
            installation: observable,
            installations: observable,
            installationReference: observable,
            isLoading: observable,
            otpError: observable,
            otpLastSent: observable,
            searchDetails: observable,
            searchError: observable,
            page: observable,
            otpDetails: observable,
            updateInstallation: action,
            updateInstallations: action,
            updateOtpError: action,
            updateOtpLastSent: action,
            updateSearchDetails: action,
            updateSearchError: action,
            updatePage: action,
            updateOtpDetails: action,
            updateIsLoading: action
        });
    }

    updateSearchDetails(value: SearchDetails) {
        this.searchDetails = value;
    }

    updateOtpDetails(value: OtpDetails) {
        this.otpDetails = value;
    }

    updateOtpLastSent(value: Date) {
        this.otpLastSent = value;
    }

    updateIsLoading(value: boolean) {
        this.isLoading = value;
    }

    updatePage(value: string) {
        this.page = value;

        this.onPageChange(value);
    }

    updateInstallations(value: Array<Installation>) {
        this.installations = value;
        cache.set(value);
    }

    updateInstallation(value: Installation) {
        this.installation = value;
    }

    updateInstallationReference(value: string) {
        this.installationReference = value;
    }

    updateOtpError(value: string | undefined) {
        this.otpError = value;
    }

    updateSearchError(value: string | undefined) {
        this.searchError = value;
    }
}

export default TrackingStore;
